import { useEffect, useState, memo } from "react";
import { Line } from "react-chartjs-2";
import { http } from "../helper";
import { BaseUrl } from "../common/config";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const Weeklyreport = memo(({ }) => {
    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [isLoading, setIsLoading] = useState(true);
    const [reportType, setReportType] = useState("yearly");
    const [months, setMonths]=useState('9');
    const [quarter, setQuarter] = useState('1');

    // Custom plugin to display "No data found"
    const noDataPlugin = {
        id: "noDataPlugin",
        beforeDraw: (chart) => {
            const { datasets } = chart.data;
            const hasData = datasets.some((dataset) => dataset.data.length > 0);

            if (!hasData) {
                const ctx = chart.ctx;
                const { width, height } = chart;

                ctx.save();
                ctx.clearRect(0, 0, width, height);
                ctx.textAlign = "center";
                ctx.textBaseline = "middle";
                ctx.font = "16px Arial";
                ctx.fillStyle = "#eb9f9d";
                ctx.fillText(
                    "Sorry, no data found for your filtered search.",
                    width / 2,
                    height / 2
                );
                ctx.restore();
            }
        },
    };

    const [topSellerChartData, setTopSellerChartData] = useState({
        labels: [],
        datasets: [
            {
                label: "Weekly report",
                data: [],
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
        ],
    });

     const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
    const fiscalMonthMap = MonthNames.reduce((acc, name, index) => {
        const monthNumber = ((index + 8) % 12) + 1;
        acc[monthNumber] = name;
        return acc;
      }, {});
    const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8
      
    const quarterNames = {
        1: "Sep - Nov",
        2: "Dec - Feb",
        3: "Mar - May",
        4: "Jun - Aug"
    };

    // Function to get current fiscal quarter based on today's date
    const getCurrentFiscalQuarter = () => {
        const month = new Date().getMonth() + 1; // 1–12
        if (month >= 9 && month <= 11) return 1;   // Sep–Nov
        if (month === 12 || month <= 2) return 2;  // Dec–Feb
        if (month >= 3 && month <= 5) return 3;    // Mar–May
        return 4;                                  // Jun–Aug
    };

    const getAvailableQuarters = (selectedFiscalYear) => {
        const currentFiscalYear = getCurrentFiscalYear();
        const currentQuarter = getCurrentFiscalQuarter();

        return Object.entries(quarterNames)
            .filter(([quarterNumber]) => {
                if (selectedFiscalYear === currentFiscalYear) {
                    return Number(quarterNumber) <= currentQuarter;
                }
                return true; // show all for past years
            })
            .map(([quarterNumber, label]) => (
            <option key={quarterNumber} value={quarterNumber}>
                {label}
            </option>
            ));
        };

    const sumObj = (objArr) => {
        var newObj = {};

        objArr.forEach(function (obj) {
            if (obj.fiscalWeek in newObj) {
                newObj[obj.fiscalWeek] += obj.amount;
            } else {
                newObj[obj.fiscalWeek] = obj.amount;
            }
        });

        var arr = [];

        for (var prop in newObj) {
            arr.push({ _id: Number(prop), amount: newObj[prop] });
        }

        return arr;
    };

    useEffect(() => {

        let validMonthNumbers = [];
        if (reportType === 'monthly') {
            validMonthNumbers = visibleMonthNames.map((_, index) => ((index + 8) % 12) + 1);
            const currentMonthNumber = Number(months);
            // If the selected month is not valid for the selected year reset it to first valid month
            if (!validMonthNumbers.includes(currentMonthNumber)) {
                setMonths(validMonthNumbers[0].toString());
                return; // Skip API call until month is corrected
            }
        }
        if (reportType === 'quarterly') {
            const currentFiscalYear = getCurrentFiscalYear();
            const currentQuarter = getCurrentFiscalQuarter();
            const selectedQuarter = Number(quarter);
            //if the selected quarter is not valid reset it to current quarter
            if (period === currentFiscalYear && selectedQuarter > currentQuarter) {
                setQuarter(currentQuarter.toString());
                return; 
            }
        }
        setIsLoading(true);
        let URL3 = BaseUrl + "admin/weeklyreport";

         let payload = { period: period, type: reportType };
        if (reportType === "monthly") {
            payload.value = Number(months);
        } else if (reportType === "quarterly") {
            payload.value = Number(quarter);
        }

        http
            .post(URL3, payload)
            .then((response) => {
                setIsLoading(false);

                let chartData = sumObj(response?.data?.data);
                // Filter incomplete last week if current FY and current month/quarter
                if (period === getCurrentFiscalYear()) {
                    if (
                        (reportType === "monthly" && Number(months) === (new Date().getMonth() + 1)) ||
                        (reportType === "quarterly" && Number(quarter) === getCurrentFiscalQuarter())
                    ) {
                        chartData = chartData.slice(0, -1); // Remove last week 
                    }
                }

                if (reportType === "yearly" && period === getCurrentFiscalYear()) {
                    chartData = [...chartData.slice(0, -1)];
                }
               
                setTopSellerChartData({
                    labels: chartData.map(item => item._id),
                    datasets: [
                        {
                            label: "Revenue (£)",
                            data: chartData.map((item) => item.amount),
                            borderColor: "rgb(255, 99, 132)",
                            backgroundColor: "rgba(255, 99, 132, 0.5)",
                        },
                    ],
                });
            })
            .catch((err) => {
                console.log(err);
                setIsLoading(false);
            });
    }, [period,reportType, months, quarter]);

    const changePeriodHandler = (e) => {
        setPeriod(e.target.value);
    };
       const changeHandler = (e) => {
        setReportType(e.target.value);
    };
    const changeMonthHandler = (e) => {
        setMonths(e.target.value);
    };
    const changeQuarterHandler = (e) => {
        setQuarter(e.target.value);
    };
    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
          }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }
    const currentFiscalYear = getCurrentFiscalYear();
    let visibleMonthNames = MonthNames;
    if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
    }
    let loadingbuffer = isLoading ? "loading-buffer" : "";
    return (
        <div className={`chart-container chart-week-revenue ${loadingbuffer}`}>
            <div className="chart-Hdr">
                <h2 style={{ textAlign: "left" }}>Weekly Revenue Analysis{"  "}</h2>
                <div className="chart-fltr">
                    <select value={reportType}
                            onChange={(e) => changeHandler(e)}
                        > 
                        <option value={"monthly"}>Monthly</option>
                        <option value={"quarterly"}>Quarterly</option>
                        <option value={"yearly"}>FY Data</option>
                    </select>
                    {reportType === 'monthly' && 
                        (<select value={months} onChange={(e)=>changeMonthHandler(e)}>
                         {visibleMonthNames.map((monthName, index) => {
                            const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                            return (
                                <option key={monthNumber} value={monthNumber}>
                                {monthName}
                                </option>
                            );
                            })}
                        </select>
                        )}

                         {reportType === 'quarterly' && (
                            <select  value={quarter} onChange={changeQuarterHandler}>
                            {getAvailableQuarters(period)}
                            </select>
                        )}
                     {(reportType === 'monthly' || reportType === 'quarterly' || reportType === 'yearly') && (<select
                           
                            value={period}
                            onChange={(e) => changePeriodHandler(e)}
                            >
                            {options}
                        </select>
                        )}
                       
                </div>
            </div>
            {topSellerChartData && (
                <Line
                    data={topSellerChartData}
                    plugins={[noDataPlugin]}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false,
                            },
                            title: {
                                display: false,
                                text: "Weekly revenue analysis",
                            },
                            datalabels: {
                                display: false,
                                font: {
                                    weight: "bold",
                                },
                                anchor: "end",
                                align: "top",
                                formatter: function (value) {
                                    return "£" + value;
                                },
                            },
                            tooltip: {
                                callbacks: {
                                    title: (tooltipItems) => {
                                        const index = tooltipItems[0].label;
                                        return `Week ${index}`;
                                    },
                                },
                            },
                        },
                    }}
                />
            )}
        </div>
    );
});
